import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SEOContent() {
  const { t } = useTranslation();

  const comparisonRows = [
    { featureKey: 'compare.row_org', itaobuy: '⭐⭐⭐⭐⭐', manual: '⭐⭐' },
    { featureKey: 'compare.row_speed', itaobuy: 'compare.alta', manual: 'compare.bassa' },
    { featureKey: 'compare.row_compare', itaobuy: 'compare.semplice', manual: 'compare.complesso' },
    { featureKey: 'compare.row_updates', itaobuy: 'compare.possibili', manual: 'compare.limitati' },
    { featureKey: 'compare.row_ux', itaobuy: 'compare.ottima', manual: 'compare.media' },
  ];

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto">
        {/* SEO Content */}
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
          {t('seo.section_title')}
        </h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
          {t('seo.intro')}
        </p>

        <article className="space-y-8">
          <div>
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
              {t('seo.h2_1')}
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              {t('seo.p1')}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
              {t('seo.h2_2')}
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              {t('seo.p2')}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
              {t('seo.h2_3')}
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              {t('seo.p3')}
            </p>
          </div>
        </article>

        {/* Comparison Table */}
        <div className="mt-16">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
            {t('compare.title')}
          </h2>
          <div className="overflow-hidden rounded-2xl border border-background-200/60 bg-background-50">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200/60 bg-background-100">
                  <th className="text-left px-6 py-4 font-label text-sm font-semibold text-foreground-800">
                    {t('compare.col_feature')}
                  </th>
                  <th className="text-center px-6 py-4 font-label text-sm font-semibold text-primary-600">
                    {t('compare.col_itaobuy')}
                  </th>
                  <th className="text-center px-6 py-4 font-label text-sm font-semibold text-foreground-500">
                    {t('compare.col_manual')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonRows.map((row, idx) => (
                  <tr key={idx} className="border-b border-background-100 last:border-0">
                    <td className="px-6 py-4 text-sm text-foreground-800 font-medium">{t(row.featureKey)}</td>
                    <td className="px-6 py-4 text-center text-sm font-semibold text-primary-600">{t(row.itaobuy)}</td>
                    <td className="px-6 py-4 text-center text-sm text-foreground-500">{t(row.manual)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Article Link */}
        <div className="mt-12 text-center">
          <Link
            to="/articolo/guida-completa-itaobuy-spreadsheet"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 border border-background-200 text-foreground-800 font-label text-sm font-medium hover:bg-primary-50 hover:border-primary-200 hover:text-primary-700 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('seo.article_link')}
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>

        {/* FAQ Preview */}
        <div className="mt-16">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
            Domande Frequenti su Itaobuy Spreadsheet
          </h2>
          <div className="space-y-3">
            {[
              { q: 'Cos\'è Itaobuy Spreadsheet?', a: 'Itaobuy Spreadsheet è una piattaforma che organizza prodotti e categorie in formato tabellare, facilitando la ricerca e il confronto tra migliaia di articoli di moda e accessori.' },
              { q: 'Come si usa Itaobuy Spreadsheet?', a: 'Basta selezionare una categoria dal menu a tendina o dalla griglia prodotti per accedere alle liste organizzate. Ogni categoria ti porta direttamente ai prodotti disponibili con tutte le informazioni necessarie.' },
              { q: 'Itaobuy Spreadsheet è gratuito?', a: 'L\'accesso alle informazioni e alle categorie di Itaobuy Spreadsheet è completamente gratuito. Puoi esplorare tutte le categorie senza alcun costo.' },
              { q: 'Quali categorie sono disponibili?', a: 'Sono disponibili 14 categorie: Scarpe, Felpe/Maglioni, T-Shirt, Giacche, Pantaloni/Corti, Cappelli, Set, Intimo, Maglie Sportive, Accessori, Borse, Cinture, Profumi e Altro.' },
            ].map((faq, idx) => (
              <details key={idx} className="group bg-background-50 rounded-xl border border-background-200/60">
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer font-label text-sm font-medium text-foreground-800 list-none">
                  {faq.q}
                  <i className="ri-add-line group-open:rotate-45 transition-transform w-5 h-5 flex items-center justify-center text-foreground-400"></i>
                </summary>
                <p className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}